var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"js-jobs-container builds-container"},_vm._l((_vm.jobs),function(job){return _c('job-container-item',{key:job.id,attrs:{"job":job,"is-active":_vm.isJobActive(job.id)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }